import { X } from "lucide-react";
import type { EstadoLicitacion, TipoContrato, Prioridad } from "@/types/licitacion";

interface LicitacionFiltersProps {
  estado: EstadoLicitacion | "";
  tipoContrato: TipoContrato | "";
  prioridad: Prioridad | "";
  onEstadoChange: (estado: EstadoLicitacion | "") => void;
  onTipoContratoChange: (tipo: TipoContrato | "") => void;
  onPrioridadChange: (prioridad: Prioridad | "") => void;
  onClear: () => void;
}

const estadoLabels: Record<EstadoLicitacion, string> = {
  BORRADOR: "Borrador", EN_ANALISIS: "En An\u00e1lisis", EN_PREPARACION: "En Preparaci\u00f3n",
  PRESENTADA: "Presentada", EN_EVALUACION: "En Evaluaci\u00f3n", ADJUDICADA: "Adjudicada",
  RECHAZADA: "Rechazada", DESIERTA: "Desierta", CANCELADA: "Cancelada",
};

const tipoLabels: Record<TipoContrato, string> = {
  SERVICIOS: "Servicios", SUMINISTROS: "Suministros", OBRAS: "Obras",
  CONCESION_SERVICIOS: "Concesi\u00f3n Servicios", CONCESION_OBRAS: "Concesi\u00f3n Obras", MIXTO: "Mixto",
};

const prioridadLabels: Record<Prioridad, string> = { BAJA: "Baja", MEDIA: "Media", ALTA: "Alta", URGENTE: "Urgente" };

const sel = "px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none";

export function LicitacionFilters({ estado, tipoContrato, prioridad, onEstadoChange, onTipoContratoChange, onPrioridadChange, onClear }: LicitacionFiltersProps) {
  const hasFilters = estado !== "" || tipoContrato !== "" || prioridad !== "";

  return (
    <div className="flex flex-wrap gap-3 items-center">
      <select value={estado} onChange={(e) => onEstadoChange(e.target.value as EstadoLicitacion | "")} className={sel}>
        <option value="">Estado: Todos</option>
        {(Object.keys(estadoLabels) as EstadoLicitacion[]).map((k) => <option key={k} value={k}>{estadoLabels[k]}</option>)}
      </select>
      <select value={tipoContrato} onChange={(e) => onTipoContratoChange(e.target.value as TipoContrato | "")} className={sel}>
        <option value="">Tipo: Todos</option>
        {(Object.keys(tipoLabels) as TipoContrato[]).map((k) => <option key={k} value={k}>{tipoLabels[k]}</option>)}
      </select>
      <select value={prioridad} onChange={(e) => onPrioridadChange(e.target.value as Prioridad | "")} className={sel}>
        <option value="">Prioridad: Todos</option>
        {(Object.keys(prioridadLabels) as Prioridad[]).map((k) => <option key={k} value={k}>{prioridadLabels[k]}</option>)}
      </select>
      {hasFilters && (
        <button onClick={onClear} className="flex items-center gap-1 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
          <X className="h-4 w-4" /> Limpiar filtros
        </button>
      )}
    </div>
  );
}
